export function fmtNumber(num) {
  return `${num}`.replace(/(?:\.0*|(\.\d+?)0+)$/, '$1')
}